// extracted by mini-css-extract-plugin
export var button = "GooglePayButton-module__button___jIPXv";
export var container = "GooglePayButton-module__container___JsS5B";